var $ac16a2aa6b3fd4ae$exports = {};
$ac16a2aa6b3fd4ae$exports = {
    "clear": `\u{645}\u{633}\u{62D}`,
    "invalid": `(\u{63A}\u{64A}\u{631} \u{635}\u{627}\u{644}\u{62D})`,
    "loading": `\u{62C}\u{627}\u{631}\u{64D} \u{627}\u{644}\u{62A}\u{62D}\u{645}\u{64A}\u{644}...`,
    "noResults": `\u{644}\u{627} \u{62A}\u{648}\u{62C}\u{62F} \u{646}\u{62A}\u{627}\u{626}\u{62C}`,
    "valid": `(\u{635}\u{627}\u{644}\u{62D})`
};


export {$ac16a2aa6b3fd4ae$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
